import ReactDOM from "react-dom/client";

import * as Sentry from "@sentry/react";

import { App } from "@app/App";

import "./index.css";

Sentry.init({
  dsn: Config.dsn,
  environment: Config.envName,
  tracePropagationTargets: [
    /^https:\/\/api\.user\.takima\.io/,
    /^https:\/\/api\.user\.takima\.cloud/,
    /^https:\/\/api\.user\.takima\.dev/,
  ],
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
